import React, { FC } from 'react';
import { useRouteMatch, Route, Switch, Redirect } from 'react-router-dom';
import ListMenuItem from './pages/List';

const MenuItems: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/:location`} component={ListMenuItem} />
      <Route path={`${path}`}>
        <Redirect to="/users" />
      </Route>
    </Switch>
  );
};

export default MenuItems;
